import React from 'react';

import { parseActivityHTML } from '@utils/activity-utils';

import { IActivityEntityBase } from '.';

interface IActivityTemplate {
  activity: IActivityEntityBase;
}

const ActivityTemplate: React.FC<IActivityTemplate> = ({ activity }) => {
  const body = parseActivityHTML(activity);

  return <div dangerouslySetInnerHTML={{ __html: body }} />;
};

export default ActivityTemplate;
